module.exports = __webpack_public_path__ + "static/media/cert_75.d75c0b99.jpg";